import * as React from 'react';
import styled from '@emotion/styled';

export interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode;
}

const Label = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: ${({ theme }) => theme.fontSize.base};
  color: ${({ theme }) => theme.color.fg.default};
  cursor: pointer;
  user-select: none;
`;

const Native = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

const Dot = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.color.border.strong};
  background: ${({ theme }) => theme.color.bg.default};
  display: grid;
  place-items: center;
  flex-shrink: 0;
  transition: all ${({ theme }) => theme.motion.fast} ${({ theme }) => theme.motion.ease};

  &::after {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #fff;
    transform: scale(0);
    transition: transform ${({ theme }) => theme.motion.fast} ${({ theme }) => theme.motion.ease};
  }

  ${Label}:hover & { border-color: ${({ theme }) => theme.color.primary.base}; }
  ${Native}:checked + & {
    background: ${({ theme }) => theme.color.primary.base};
    border-color: ${({ theme }) => theme.color.primary.base};
  }
  ${Native}:checked + &::after { transform: scale(1); }
`;

/** Lumen radio — single-select among 2–5 options. Share `name` across a group. */
export function Radio({ label, children, ...rest }: RadioProps) {
  return (
    <Label>
      <Native type="radio" {...rest} />
      <Dot />
      {label ?? children}
    </Label>
  );
}
